import * as React from 'react';
import { useRecoilState } from 'recoil';
import { playerSpeedAtom } from './RidePlayerState';
import useAnalytics from '../../hooks/useAnalytics';

const availableSpeeds: number[] = [1, 2, 4, 8, 16, 32, 64];

interface IRidePlayerSpeedMenuProps {
  closeCallback: () => void;
}

function RidePlayerSpeedMenu(props: IRidePlayerSpeedMenuProps): JSX.Element {
  const { trackEvent } = useAnalytics();
  const [playerSpeed, setPlayerSpeed] = useRecoilState<number>(playerSpeedAtom);

  const handleSpeed = (event: React.ChangeEvent<HTMLInputElement>) => {
    trackEvent(['Ride Player speed menu', 'click', `Set player speed: ${event.currentTarget.value}x`]);
    setPlayerSpeed(Number(event.currentTarget.value));
    props.closeCallback();
    // Saving settings is in useEffect hook in index.tsx
  };

  return (
    <div className="set-play-speed active">
      <div className="my-2 font-weight-bold">Rýchlosť prehrávania</div>
      {availableSpeeds.map((speed: number, index: number) => {
        return (
          <div className="my-2 ml-2" key={`player-speed-${speed}-${index}`}>
            <div className="e-radio">
              <label>
                <input
                  type="radio"
                  name="set-player-speed"
                  checked={playerSpeed === speed}
                  value={speed}
                  onChange={handleSpeed}
                />
                <span className="fs-2">
                  {speed}x{speed === 1 ? ' (Normálna)' : ''}
                </span>
              </label>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default RidePlayerSpeedMenu;
